function build (model, pageData) {
  console.log('building', model)
  console.log('obj', pageData.obj)
  if (!pageData.inputs || !pageData.obj){
    return model
  }
  if (model[pageData.obj] == undefined){
    model[pageData.obj] = {}
  }
  for (var key in pageData.inputs){
    var input = pageData.inputs[key]

    
  model[pageData.obj][key] = input.value != null ? input.value : input
    
    
  }
  return model
}

module.exports = {
  build
}
